import { render, staticRenderFns } from "./noContent.vue?vue&type=template&id=35bac5e2&scoped=true"
import script from "./noContent.ts?vue&type=script&lang=ts&external"
export * from "./noContent.ts?vue&type=script&lang=ts&external"
import style0 from "./noContent.vue?vue&type=style&index=0&id=35bac5e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bac5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bac5e2')) {
      api.createRecord('35bac5e2', component.options)
    } else {
      api.reload('35bac5e2', component.options)
    }
    module.hot.accept("./noContent.vue?vue&type=template&id=35bac5e2&scoped=true", function () {
      api.rerender('35bac5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/candidates/no-content/noContent.vue"
export default component.exports